// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xtianbao_h1[data-v-1aff8148]{padding:0 20px;width:100%;margin:20px 0 0 0;height:auto;overflow:hidden;background-color:#fff}", ""]);
// Exports
module.exports = exports;
